import Vue from 'vue'
import { AgGridVue } from 'ag-grid-vue'
// resources
import ApproversResource from '../../resources/approver'
import UserResource from '../../resources/user'
import UserRoleResource from '../../resources/userRolesMx'
import DepartmentResource from '../../resources/department'

// components & views
import FormResourceEdit from '../form_resource_edit/FormResourceEdit.vue'
import AutoComplete from '../../components/Autocomplete.vue'
import approverFormSet from '../../resources/formsets/approver'
import userRoleFormSet from '../../resources/formsets/user_roles_mx'

// mixins
import toastMixin from '../../mixins/toast'
import modalMixin from '../../mixins/modal'

export default Vue.extend({
    data() {
        return {
            approversColumnDefs: [
                {
                    field: 'username',
                    editable: false,
                    sortable: true,
                    headerName: 'Username',
                    valueGetter: (params) => params.data.managers.user_id.resource.attributes.username,
                },
                {
                    field: 'approver_group',
                    editable: true,
                    sortable: true,
                    headerName: 'Tier',
                    minWidth: 50,
                    maxWidth: 80,
                    valueFormatter: (params) => params.value || 'N/A',
                    valueSetter: (params) => {
                        params.data.set('approver_group', params.newValue || null)
                    },
                    valueGetter: (params) => params.data.attributes.approver_group,
                },
                {
                    field: 'approver_type',
                    editable: true,
                    sortable: true,
                    headerName: 'Approver Type',
                    minWidth: 80,
                    maxWidth: 120,
                    valueFormatter: (params) => {
                        if (!params || typeof params.value === 'undefined') return null
                        switch (String(params.value)) {
                            case '0':
                                return 'Both'

                            case '1':
                                return 'Timecards'

                            case '2':
                                return 'Starts'

                            case '3':
                                return 'Observer'

                            default:
                                return 'None/Error'
                        }
                    },
                    valueSetter: (params) => {
                        if (!params || typeof params.newValue === 'undefined') return null
                        if (params.newValue === '3') {
                            params.data.set('approver_group', null)
                            params.data.set('final_approver', '0')
                            params.data.set('send_notifications', '0')
                        }
                        params.data.set('approver_type', params.newValue)
                    },
                    valueGetter: (params) => params.data.attributes.approver_type,
                    cellEditor: 'agSelectCellEditor',
                    cellEditorParams: {
                        values: ['0', '1', '2', '3'],
                    },
                },
                {
                    field: 'department_id',
                    editable: true,
                    sortable: true,
                    headerName: 'Dept',
                    minWidth: 50,
                    maxWidth: 80,
                    valueFormatter: (params) => params.value || 'Default',
                    valueSetter: (params) => {
                        params.data.set('department_id', params.newValue)
                    },
                    valueGetter: (params) => params.data.attributes.department_id,
                },
                {
                    field: 'department',
                    editable: false,
                    sortable: true,
                    headerName: 'Department',
                    valueFormatter: (params) => params.value || 'Default',
                    valueSetter: (params) => {
                        params.data.set('department', params.newValue)
                    },
                    valueGetter: (params) => params.data.attributes.department,
                },
                {
                    field: 'final_approver',
                    editable: true,
                    sortable: true,
                    headerName: 'Bypass',
                    minWidth: 80,
                    maxWidth: 80,
                    valueSetter: (params) => {
                        params.data.set('final_approver', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.final_approver
                    },
                },
                {
                    field: 'send_notifications',
                    editable: true,
                    sortable: true,
                    headerName: 'Notifications (this tier)',
                    minWidth: 50,
                    maxWidth: 170,
                    valueSetter: (params) => {
                        params.data.set('send_notifications', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.send_notifications
                    },
                },
                {
                    field: 'email',
                    editable: false,
                    sortable: true,
                    headerName: 'Email',
                    valueSetter: (params) => {
                        let resource = params.data.managers.user_id.resource
                        resource.set('email', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.managers.user_id.resource.attributes.email
                    },
                },
                {
                    field: 'status',
                    editable: true,
                    sortable: true,
                    headerName: 'Status',
                    minWidth: 30,
                    maxWidth: 80,
                    valueSetter: (params) => {
                        params.data.set('status', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.status
                    },
                },
                {
                    field: 'time_updated',
                    editable: false,
                    sortable: true,
                    headerName: 'Time Updated',
                    valueGetter: (params) => new Date(params.value),
                    valueSetter: (params) => {
                        params.data.set('time_updated', params.newValue)
                    },
                    valueGetter: (params) => params.data.attributes.time_updated,
                },
            ],
            approversRowData: [],
            approverResources: undefined,
            addApproverResource: undefined,
            addUserRoleResource: undefined,
            autoCompleteResource: undefined,
            selectedResource: undefined,
            gridOptions: null,
            userRoleForm: false,
            approverForm: false,
        }
    },
    mixins: [toastMixin, modalMixin],
    props: {
        entityId: {
            type: String,
            required: false,
        },
        entityResource: {
            type: Object,
            required: false,
        },
    },
    components: {
        AgGridVue,
        FormResourceEdit,
        AutoComplete,
    },
    computed: {
        formsets() {
            return {
                approverFormSet,
                userRoleFormSet,
            }
        },
    },
    methods: {
        async fetchApproversByEntityId(entityId) {
            const approverResourceResponses = await ApproversResource.all({ entity_id: entityId })
            const pendingManagers = []
            const approverResources = approverResourceResponses.map((resource) => {
                let userResourceManagerpromise = resource.managers.user_id.resolve()
                pendingManagers.push(userResourceManagerpromise)
                return resource
            })
            Promise.all(pendingManagers)
                .then(async () => {
                    let departmentPromises = []
                    approverResources.forEach((resource) => {
                        // pushing null to keep dept resources lined up with approver resources
                        if (resource.attributes.department_id) {
                            let departmentResource = DepartmentResource.detail(resource.attributes.department_id)
                            departmentPromises.push(departmentResource)
                        } else {
                            departmentPromises.push(null)
                        }
                    })
                    const resolvedDeptartmentResources = await Promise.all(departmentPromises)
                    approverResources.forEach((resource, i) => {
                        if (resource.attributes.department_id) {
                            resource.attributes.department = resolvedDeptartmentResources[i].attributes.name
                            // deleting the changes that happened from adding dept name
                            delete resource.changes.department
                        }
                    })
                    return approverResources
                })
                .then((modifiedApproverResources) => {
                    this.approverResources = this.approversRowData = modifiedApproverResources
                })
                .catch((e) => {
                    this.createToast('b-toaster-top-center', 'danger', true, 'Error getting Entity', 'Was not able to fetch the entity')
                })
        },
        async save() {
            let promises = []
            this.approverResources.forEach((resource) => {
                let userResourceManager = resource.managers.user_id
                let errors = resource.validate()

                if (errors.length) {
                    this.handleErrors(errors)
                } else {
                    if (userResourceManager.resolved && Object.keys(userResourceManager.resource.changes).length) {
                        let userResourceSavePromise = userResourceManager.resource
                            .save()
                            .then((result) => {
                                if (result.response.status > 200 || result.response.status < 299) {
                                    this.createToast('b-toaster-top-center', 'success', true, 'User Updated', 'User was updated')
                                    this.fetchApproversByEntityId(this.entityId)
                                }
                            })
                            .catch(() => {
                                this.createToast('b-toaster-top-center', 'danger', true, 'Update Error', 'The user was not updated')
                            })
                        promises.push(userResourceSavePromise)
                    }

                    if (Object.keys(resource.changes).length) {
                        // changed department id back to null if changes are null
                        resource.changes.department_id = resource.changes.department_id == 0 ? null : resource.changes.department_id
                        let approverResourcePromise = resource
                            .save()
                            .then(async (result) => {
                                if (result.response.status > 200 || result.response.status < 299) {
                                    this.createToast('b-toaster-top-center', 'success', true, 'Approver Updated', 'Approver was updated')
                                    this.fetchApproversByEntityId(this.entityId)
                                }
                            })
                            .catch(() => {
                                this.createToast('b-toaster-top-center', 'danger', true, 'Approver Error', 'The approver was not updated')
                            })
                        promises.push(approverResourcePromise)
                    }
                    return Promise.all(promises).then(() => undefined)
                }
            })
        },
        onGridReady(params) {
            this.gridApi = params.api
            this.columnApi = params.columnApi
        },
        onSelectionChanged() {
            const selectedRow = this.gridApi.getSelectedRows()
            this.$emit('approverRowClicked', selectedRow)
        },
        userSelectedResource(resource) {
            this.selectedResource = resource
            this.addApproverResource = new ApproversResource()
            this.addUserRoleResource = new UserRoleResource()

            this.addUserRoleResource.set('entity_id', parseInt(this.entityId))
            this.addUserRoleResource.set('user_id', parseInt(resource.id))
            this.addUserRoleResource.set('company_id', 1)
            this.addUserRoleResource.set('role_id', 5)

            this.addApproverResource.set('user_id', parseInt(resource.id))
            this.addApproverResource.set('entity_id', parseInt(this.entityId))
            this.addApproverResource.set('send_notifications', 1)
            this.addApproverResource.set('status', 1)
        },
        displayAddApproverForm() {
            this.autoCompleteResource = UserResource
            this.userRoleForm = true
            this.approverForm = false
            this.showModal('add-approver')
        },
        addUserRole() {
            let promises = []
            let errors = this.addUserRoleResource.validate()

            if (errors.length) {
                this.handleErrors(errors)
            } else {
                let userRoleResourcePromise = this.addUserRoleResource
                    .save()
                    .then((result) => {
                        if (result.response.status > 200 || result.response.status < 299) {
                            this.createToast('b-toaster-top-center', 'success', true, 'Approver Added', 'Approver was added')
                            this.userRoleForm = !this.userRoleForm
                            this.approverForm = !this.approverForm
                        }
                    })
                    .catch(() => {
                        this.createToast('b-toaster-top-center', 'danger', true, 'Approver Error', 'The approver was not added')
                    })
                promises.push(userRoleResourcePromise)
            }
            return Promise.all(promises).then(() => {
                this.fetchApproversByEntityId(this.entityId)
            })
        },
        addApprover() {
            let promises = []
            let errors = this.addApproverResource.validate()

            if (errors.length) {
                this.handleErrors(errors)
            } else {
                let approverResourcePromise = this.addApproverResource
                    .save()
                    .then((result) => {
                        if (result.response.status > 200 || result.response.status < 299) {
                            this.createToast('b-toaster-top-center', 'success', true, 'Approver Added', 'Approver was added')
                            this.approverForm = !this.approverForm
                            this.closeModal('add-approver')
                        }
                    })
                    .catch(() => {
                        this.createToast('b-toaster-top-center', 'danger', true, 'Approver Error', 'The approver was not added')
                    })
                promises.push(approverResourcePromise)
            }
            return Promise.all(promises).then(() => undefined)
        },
        refreshApproverGrid() {
            this.fetchApproversByEntityId(this.entityId)
        },
        skipForm(currentForm) {
            if (!this.selectedResource) return this.createToast('b-toaster-top-center', 'danger', true, 'Error', 'Select a user before skipping')

            if (currentForm === 'userRoleForm') {
                this.userRoleForm = false
                this.approverForm = true

                this.addApproverResource = new ApproversResource()
                this.addApproverResource.set('user_id', parseInt(this.selectedResource.id))
                this.addApproverResource.set('entity_id', parseInt(this.entityId))
                this.addApproverResource.set('send_notifications', 1)
                this.addApproverResource.set('status', 1)
                this.addApproverResource.set('company_id', 1)
            } else {
                this.approverForm = false
                this.closeModal('add-approver')
            }
        },
    },
    watch: {
        entityId: function(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.fetchApproversByEntityId(newVal)
            }
        },
    },
    beforeMount() {
        this.gripOptions = {}
    },
    async mounted() {
        this.fetchApproversByEntityId(this.entityId)
    },
})
